enum AssetDataSource {
    LOS = 'los_asset',
    WRITE_IN = 'write_in',
}

export default AssetDataSource
